// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O6Jq","col":"styles_col__1jIXP"};